import DistribuidorMasterService from "@/services/DistribuidorMasterService";

export const distribuidorMaster = {
  namespaced: true,
  state: {
    distribuidorMaster: {},
  },
  actions: {
    getDistribuidorMaster({ commit }, payload) {
      return DistribuidorMasterService.GetDistribuidorMaster(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postDistribuidorMaster({ commit }, payload) {
      return DistribuidorMasterService.PostDistribuidorMaster(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putDistribuidorMaster({ commit }, payload) {
      return DistribuidorMasterService.PutDistribuidorMaster(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteDistribuidorMaster({ commit }, payload) {
      return DistribuidorMasterService.DeleteDistribuidorMaster(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getDistribuidorMasterOData({ commit }, payload) {
      return DistribuidorMasterService.GetDistribuidorMasterOData(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default distribuidorMaster;
